const Subtitle = ({ children, as = 'p' }) => {
    const Tag = as;
    return <Tag className="subtitle">{children}</Tag>;
};

export default Subtitle;

